export enum TransactionType {
    BUY = 'BUY',
    SELL = 'SELL',
    DIVIDEND = 'DIVIDEND',
    INTEREST = 'INTEREST',
    TRANSFER = 'TRANSFER'
}